<template>
  <div class="welcome-page">
    <div class="welcome-content">
      <img class="welcome-banner" :src="homeBanner" alt="欢迎页" />
      <div class="welcome-title">欢迎进入护理后台管理系统</div>
    </div>
  </div>
</template>

<script>
import homeBanner from '@/assets/img/home-banner.png'

export default {
  name: 'Welcome',
  data () {
    return {
      homeBanner
    }
  }
}
</script>

<style scoped>
.welcome-page {
  width: 100%;
  min-height: calc(100vh - 220px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}

.welcome-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translateY(-8%);
}

.welcome-banner {
  width: 270px;
  max-width: 80vw;
  display: block;
}

.welcome-title {
  margin-top: 34px;
  color: #999;
  font-size: 26px;
  line-height: 1.4;
  text-align: center;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/views/welcome/index.vue